
<template>
	<div class="gamedemo_page">
		<div class="active_fixed_btn">
			<div class="fix_btn" @click="nextStep()">测试跳转</div>
		</div>
	</div>
</template>

<script>
	import post from '../../../api/toyota/api';
	import { mapState } from 'vuex';
	import {Field,Uploader,Toast,Radio,RadioGroup } from 'vant';
	export default {
		data () {
			return {

			}
		},
		created () {
			this.getActiveInfo()

		},
		methods: {


			nextStep(){

				window.open('weixin://dl/business/?appid=wx5b7aa709f5305578&path=pages/article/article&query=scene%3D5214&env_version=release')

			},

		},
		components: {
			[Field.name]: Field,
			[Uploader.name]: Uploader,
			[Toast.name]:Toast,
			[Radio.name]:Radio,
			[RadioGroup.name]:RadioGroup
		}
	};
</script>

<style lang="scss">
	.gamedemo_page {
		.active_fixed_btn{
			width: 100%;
			position: fixed;
			bottom: 50%;
			margin-top:25px;
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 2;
			.fix_btn{
				text-align: center;
				background-color: #1E2A75;
				color: #fff;
				border-radius: 25px;
				font-size: 14px;
				padding: 12px 0;
				width: 150px;
			}
		}
	}
</style>
